<template>
  <div
    class="homepageheader text-center"
  >
    <Sticky class="fixed top-0 right-0 left-0" style="z-index: 999;">
      <div
        :style="{ background: scrollTop > 20 ? '#C82D26' : '' }"
        style="transition: 0.5s"
      >
        <div class="flex flex-row justify-between p-3 pb-2 top-bar">
          <!--<div class="text-white w-16 flex justify-start">
            <div class="inline-block" @click="goBrandList">
              <img
                height="24"
                width="24"
                src="@/assets/home/brand.svg"
                alt=""
              />
              <div class="text-xxs text-center font-light">品牌</div>
            </div>
          </div>-->
          <!-- 顶部图片 src  @/assets/logo-white-title.png -->
          <div class="flex flex-col items-center justify-center flex-grow">
            <!-- <img
              :style="{
                height: scrollTop > 20 ? '0' : '18px',
              }"
              style="margin-top: 8px"
              src=""
              alt=""
            /> -->
            <Search
              ref="fakeSearch"
              :style="{
                overflow: scrollTop < 21 ? 'hidden' : '',
              }"
              class="py-0 m-0 w-full"
              @focus="goSearch"
              shape="round"
              background="transparent"
              placeholder="搜索商品"
            ></Search>
          </div>

          <div class="text-white w-16 flex justify-end">
            <div class="inline-block" v-gapclick="forward">
              <img
                height="24"
                width="24"
                src="@/assets/home/forward.svg"
                alt=""
              />
              <div class="text-xxs text-center font-light">转发</div>
            </div>

            <!-- 客户端的消息排版 -->
            <template v-if="!distributionFlag">
              <div
                class="relative inline-block ml-2"
                @click="$router.push({ name: 'HomeMessage' })"
              >
                <div
                  v-if="messageTotal"
                  class="
                    bg-white
                    w-4
                    h-4
                    rounded-full
                    absolute
                    text-xs text-red text-center
                  "
                  style="right: -4px; top: -4px; transform: scale(0.9)"
                >
                  <span>{{ messageTotal }}</span>
                </div>
                <img
                  height="24"
                  width="24"
                  src="@/assets/home/message.svg"
                  alt=""
                />
                <div class="text-xxs text-center font-light">消息</div>
              </div></template
            >

            <!-- 分销端的消息排版 -->
            <template v-else
              ><div @click="qiyuOpen" class="ml-2">
                <img
                  height="24"
                  width="24"
                  src="@/assets/home/message.svg"
                  alt=""
                />
                <div class="text-xxs text-center font-light">客服</div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </Sticky>
    <Swipe
      :autoplay="3000"
      class="mx-0 lightshadow bannerTopStyle"
    >
      <SwipeItem
        v-for="item in swipeList"
        :key="item.id"
        class="flex justify-center"
      >
        <VImage class="w-full" fit="fill" :src="item.bannerUrl" @click="goLink(item)" />
      </SwipeItem>
    </Swipe>
    <!-- 频道当作导航用 -->
    <div class="channel" >
        <Swipe :autoplay="5000" :show-indicators="false" @change="onChangeCardNav">
          <SwipeItem v-for="(item, index) in channel" :key="index">
            <div class="channel-panel">
              <div
                class="channel-item"
                :class="['row-' + style.cell]"
                v-for="_item in item"
                :key="_item.id"
                @click="goLink(_item)"
              >
                <img :src="_item.channelImg" />
                <div class="tit text-black" :class="{'text-red-600':activeCate==_item.linkId}">{{ _item.channelName }}</div>
              </div>
            </div>
          </SwipeItem>
          <template #indicator v-if="channel.length>1">
            <div class="flex justify-center">
              <div class="custom-indicator bg-stone-300" :class="{'bg-red-600':i==currentCardNav}" v-for="i in channel.length" :key="i"></div>
            </div>
          </template>
        </Swipe>
    </div>
    <div v-show="activeTab === 'home'">

      <!-- 暂时隐藏 -->
      <!-- <div
        class="
          flex flex-no-wrap
          rounded-full
          text-white text-xxs
          justify-evenly
          mx-3
          my-2
        "
        style="background-color: rgba(0, 0, 0, 0.07)"
      >
        <span>运费险</span><span>七天无理由</span><span>品质保证</span
        ><span>全场包邮</span><span>48小时发货</span><span>慢贵必赔</span>
      </div> -->
      <img
        :src="middleBanner.bannerUrl"
        alt=""
        class="w-full"
        @click="goLink(middleBanner)"
      />
      <img
        :src="bottomBanner.bannerUrl"
        alt=""
        class="w-11/12 mx-auto"
        @click="goLink(bottomBanner)"
      />
      <div class="flex flex-row text-left pl-3 pr-3">
        <!-- 好评top榜 -->
        <TopList v-if="isShowPraise" />
        <div class="flex-grow flex flex-col ml-3">
          <!-- 免费抢好货 -->
          <FreeGoods v-if="isShowFreeGrab" />
          <!-- 新人会场 -->
          <Newcomer v-if="isShowNewcomer" />
        </div>
      </div>
      <VImage
        :src="endBanner.bannerUrl"
        class="p-3 pb-0 w-full"
        @click="goLink(endBanner)"
        v-if="endBanner.bannerUrl"
      />
    </div>
    <Overlay
      :show="showShare"
      v-if="browserType !== 'weixin'"
      @click="showShare = false"
      style="z-index: 2"
    >
    </Overlay>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import TopList from "./components/TopList";
import FreeGoods from "./components/FreeGoods";
import Newcomer from "./components/Newcomer";
import { priceMarkup, lotteryShare, doubleShare } from "@/api/forward.js";
import {
  Toast,
  Search,
  Swipe,
  SwipeItem,
  Image as VImage,
  Overlay,
  Sticky,
} from "vant";
import {
  getPlatFormCate,
  getHomeBanner,
  getHomeBackground,
  getMiddleBanner,
  getBottomBanner,
  getEndBanner,
  getChannel,
  getChannelStyle,
} from "./webApi";
import { getDoubleCommissionDetail } from "@/api/doubleCommission";
import { getLotteryPlaceDetail } from "@/api/lotteryPlace";
import { getNewcomerDetail } from "@/api/newcomer";
import { getTopListDetail } from "@/api/topList";
import { getFreeGoodsDetail } from "@/api/freeGoods";
import { isWechatMP } from "@/utils/qiyukf";
import { getToken } from "@/utils/auth";
import map from "lodash/map";
export default {
  name: "HomepageHeader",
  props: {
    msg: String,
    act1: {
      type: String,
      default: null,
    },
  },
  components: {
    Search,
    Swipe,
    SwipeItem,

    TopList,
    FreeGoods,
    Newcomer,
    VImage,
    Overlay,
    Sticky,
  },
  created() {
    this.getAdvertising();
    getPlatFormCate().then(({ data }) => {
      this.cateList = data;
    });
    getHomeBanner().then(({ data }) => {
      this.swipeList = data.filter((item) => item.bannerUrl);
      // this.swipeList = [{ id: 1, bannerUrl: 'https://xt-vc.oss-cn-hangzhou.aliyuncs.com/mbp/66c59e22e4b0b8b49fc1311e.jpg' }, { id: 2, bannerUrl: 'https://xt-vc.oss-cn-hangzhou.aliyuncs.com/mbp/66a998d9e4b0b8b49afa1ef2.jpg' }];
    });

    //查询双倍佣金是否开启
    getDoubleCommissionDetail()
      .then(({ data }) => {
        this.isShowDouble = data.enabled;
      })
      .catch((err) => {
        console.log(err);
      });

    //查询抽奖转场是否开启
    getLotteryPlaceDetail()
      .then(({ data }) => {
        this.isShowLottery = data.enabled;
      })
      .catch((err) => {
        console.log(err);
      });

    //查询新人会场是否开启
    getNewcomerDetail()
      .then(({ data }) => {
        // debugger;
        this.isShowNewcomer = data.enabled;
      })
      .catch((err) => {
        console.log(err);
      });

    //查询好评Top榜是否开启
    getTopListDetail()
      .then(({ data }) => {
        // debugger;
        this.isShowPraise = data.enabled;
      })
      .catch((err) => {
        console.log(err);
      });

    //查询免费抢好货是否开启
    getFreeGoodsDetail()
      .then(({ data }) => {
        // debugger;
        this.isShowFreeGrab = data.actEnabled;
      })
      .catch((err) => {
        console.log(err);
      });
  },
  updated() {
    // 客服消息监听
    if (!isWechatMP()) {
      ysf("onunread", function (result) {
        this.qiyuTotal = result.total;
      });
    }
  },
  mounted() {
    this.initHomeActiveTab();
    document.getElementById("home").addEventListener(
      "scroll",
      () => {
        // console.log('homescroll')
        this.scrollTop = document.getElementById("home").scrollTop;
      },
      true
    );
  },
  data() {
    return {
      qiyuTotal: 0,
      // activeTab: 'home',
      activeCate: "home",
      activeTab: !this.act1 ? "home" : "act1",
      // activeCate: !this.act1 ? 'home' : 'act1',
      cateList: [],
      swipeList: [],
      background: null,
      middleBanner: {},
      bottomBanner: {},
      endBanner: {},
      channel: [],
      urlAddress: null,
      style: {
        enabled: null,
        cell: null,
      },

      showShare: false,
      browserType: localStorage.getItem("browserType"),
      scrollTop: 0,

      isShowDouble: null, //双倍佣金是否显示
      isShowLottery: null, //抽奖专场是否显示

      // 之后找大哥要3个接口,控制下面变量
      isShowPraise: null, //好评top榜是否显示
      isShowFreeGrab: null, //免费抢好货是否显示
      isShowNewcomer: null, //新人会场是否显示
      currentCardNav: 1, //当前卡片导航的索引
    };
  },
  computed: {
    messageTotal() {
      return this.qiyuTotal + this.$store.state.app.messageNum;
    },
    ...mapGetters(["distributionFlag"]),
  },
  methods: {
    initHomeActiveTab() {
      const homeActiveTab = this.$route.query.homeActiveTab;
      if (homeActiveTab) {
        this.$emit("activeTabChange", homeActiveTab);
        this.activeTab = homeActiveTab;
        this.activeCate = homeActiveTab;
      }
    },
    getAdvertising() {
      getHomeBackground().then((res) => {
        this.background = res.data.bannerUrl;
      });
      getMiddleBanner().then((res) => {
        this.middleBanner = res.data[0];
      });
      getBottomBanner().then((res) => {
        this.bottomBanner = res.data;
      });
      getEndBanner().then((res) => {
        this.endBanner = res.data;
      });
      getChannelStyle().then((res) => {
        console.log(res.data);
        this.style.enabled = res.data.enabled;
        const cell = res.data.style;
        const wrap = res.data.arrange;
        this.style.cell = cell;
        getChannel().then((res) => {
          let data = []
          data.push({
            linkId:"home",
            channelName:"首页",
            linkType:0,
            channelImg:require("@/assets/home/home.svg")
          })
          if (this.isShowLottery) {
            data.push({
              linkId:"act1",
              channelName:"抽奖专场",
              linkType:0,
              channelImg:require("@/assets/home/takeOutAward.svg")
            })
          }
          if (this.isShowDouble) {
            data.push({
              linkId:"act2",
              channelName:"双倍佣金",
              linkType:0,
              channelImg:require("@/assets/home/doubleCommission.svg")
            })
          }
          if (this.style.enabled) {
            data = [...data,...res.data]
          }
          if (wrap !== 0) {
            const step = cell * wrap;
            this.channel = this.toTwoDimension(data,step);
          } else {
            this.channel = [...data];
          }
        });
      });
    },
    goSearch() {
      this.$router.push({ name: "SearchPage", params: { text: "" } });
    },
    changeCate(item) {
      this.activeTab = item;
      this.activeCate = item;
      // this.$refs.cateSelect.toggle();
      this.$emit("activeTabChange", item);
    },
    goBrandList() {
      this.$router.push("BrandList");
    },
    goLink(item) {
      switch (item.linkType) {
        case 0:
          // this.changeCate(item.linkObject)
          this.changeCate(item.linkId);
          break;
        case 1:
          this.$router.push({
            name: "ActivityPlace",
            params: { aid: item.linkId },
          });
          break;
        case 2:
          const query = item.linkId.split("&");
          this.$router.push({
            name: "BrandPlace",
            params: { partId: query[0] },
            query: { signBrandId: query[1], actId: query[2] },
          });
          break;
        case 3:
          window.location.href = item.linkObject;
          break;
        case 5:
          this.$router.push({
            name: "DiscoveryGoodsDetail",
            params: { id: item.linkId },
          });
          break;
        default:
          break;
      }
    },
    forward() {
      if (["act1", "act2"].indexOf(this.activeTab) >= 0) {
        this.specialShare();
        return;
      }
      let urlAddress;
      if (location.hostname === "localhost") {
        urlAddress =
          window.location.origin +
          "/store" +
          "?customerId=" +
          this.$store.state.user.forwardId;
      } else {
        urlAddress =
          location.origin +
          "/store" +
          "?customerId=" +
          this.$store.state.user.forwardId;
      }
      this.urlAddress = urlAddress;
      priceMarkup({ forwardType: "STORE", urlAddress }).then(({ data }) => {
        // this.showShare = true;
        this.diagVisible = false;
        this.$store.dispatch("sharePoster/show", {
          url: data.url,
          title: this.$store.state.user.userInfoNickname,
          desc: "",
          link: urlAddress,
          imgUrl: this.$store.state.user.userInfoAvatar,
        });
      });
    },
    // 抽奖专场、双倍佣金 转发
    specialShare() {
      let forwardUrl = `${window.location.origin}?homeActiveTab=${this.activeTab}&customerId=${this.$store.state.user.forwardId}`;
      if (this.activeTab === "act1") {
        // 抽奖专场
        this.$store.dispatch("app/showLoading");
        lotteryShare({ url: forwardUrl })
          .then((res) => {
            this.$store.dispatch("app/hideLoading");

            this.sharePosterOpen(res.data, forwardUrl, {
              title: "抽奖专场",
              desc: "抽奖专场",
              imgUrl: "",
            });
          })
          .catch(() => {
            this.$store.dispatch("app/hideLoading");
          });
      }
      if (this.activeTab === "act2") {
        // 双倍佣金
        this.$store.dispatch("app/showLoading");
        doubleShare({ url: forwardUrl })
          .then((res) => {
            this.$store.dispatch("app/hideLoading");

            this.sharePosterOpen(res.data, forwardUrl, {
              title: "双倍佣金",
              desc: "双倍佣金",
              imgUrl: "",
            });
          })
          .catch(() => {
            this.$store.dispatch("app/hideLoading");
          });
      }
    },
    sharePosterOpen(url, forwardUrl, data) {
      this.$store.dispatch("sharePoster/show", {
        url,
        title: data.title,
        desc: data.desc,
        link: forwardUrl,
        imgUrl: data.imgUrl,
      });
    },

    // 打开客服
    qiyuOpen() {
      if (!isWechatMP()) {
        ysf("onready", function () {
          ysf("open");
        });
      } else {
        const customerId = this.$store.state.user.customerId;
        const token = getToken();
        const Authorization = "Bearer " + token;
        this.wxjs.miniProgram.navigateTo({
          url: `/pages/kf/kf?customerId=${customerId}&Authorization=${Authorization}`,
          success: function (res) {
            console.log("kfres success", res);
          },
          fail: function (res) {
            console.log("kfres fail", res);
          },
          events: {
            acceptDataFromOpenedPage: function (data) {
              console.log("kf", data);
            },
          },
          complete: function (res) {
            console.log("kfres complete", res);
          },
        });
      }
    },
    /**
     *   一维数组转二维数组
     * @param arr 一维数组
     * @param num 长度
     */
    toTwoDimension(arr, num=4) {
      let newArr = [];
      for (let i = 0; i < arr.length; i += num) {
        newArr.push(arr.slice(i, i + num));
      }
      return newArr;
    },
    onChangeCardNav(index){
      this.currentCardNav = index + 1;
    },
  },
};
</script>

<style lang="less" scoped>
.channel{
  background-color: #f7f7f7;
}
.channel-panel {
  display: flex;
  flex-wrap: wrap;

  .channel-item {
    padding-bottom: 20px;
    text-align: center;

    img {
      margin: 0 auto;
      width: 84px;
      height: 84px;
    }

    .tit {
      font-size: 24px;
      padding-top: 6px;
    }

    &.row-3 {
      width: 33.3%;
    }

    &.row-4 {
      width: 25%;
    }

    &.row-5 {
      width: 20%;
    }

    &.row-6 {
      width: 16.6%;
    }
  }
}
// 自定义指示器
.custom-indicator{
  width: 16px;
  height: 6px;
  &:first-child{
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
  }
  &:last-child{
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
  }
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.activeCate {
  background-color: #fff !important;
  color: #d8283b;
}
// 上方轮播图
.bannerTopStyle{
  /deep/ .van-swipe__track {
    margin-top: 0;
  }
}
/deep/ .van-swipe__track {
  margin-top: 20px;
}

.home-tab-button {
  position: absolute;
  /* px-to-viewport-ignore-next */
  // top: 12px;
  /* px-to-viewport-ignore-next */
  font-size: 14px;
  color: #fff;
  background-color: transparent;
  /* px-to-viewport-ignore-next */
  width: 72px;
  /* px-to-viewport-ignore-next */
  height: 100%;
}
::v-deep .van-tabs__line {
  border: none;
}
</style>
<style>
.transparent-dropdown .van-dropdown-menu__bar {
  background-color: transparent;
}
</style>
